import { useMainContainerSize } from '@calendly/ui/hooks/main-container-size-context';
import classNames from 'classnames';
import { ReactNode } from 'react';
/** Responsive inset for body / footer — consumers should not re-apply this. */
const paneSlotPaddingCss = "pk69pdr";
const paneRootCss = "pqimdnj";
const paneHeaderCss = "p1knl3nf";

/** Match CUI PageHeader's medium-main-container top inset. */
const paneHeaderMediumCss = "pk8olzh";

/** Match CUI PageHeader's small-main-container top inset. */
const paneHeaderSmallCss = "p1imo9d2";
const paneBodyCss = "p942hxs";
const paneFooterCss = "pqkinkx";
interface PaneSlotProps {
  children: ReactNode;
  className?: string;
}
interface PaneRootProps extends PaneSlotProps {
  'data-testid'?: string;
}
const Root = ({
  children,
  className,
  'data-testid': testId
}: PaneRootProps) => <div className={classNames(paneRootCss, className)} data-testid={testId}>
    {children}
  </div>;
const Header = ({
  children,
  className
}: PaneSlotProps) => {
  const {
    isLargeMainContainer,
    isSmallMainContainer
  } = useMainContainerSize();
  return <div className={classNames(paneHeaderCss, {
    [paneHeaderMediumCss]: !isLargeMainContainer,
    [paneHeaderSmallCss]: isSmallMainContainer
  }, className)}>
      {children}
    </div>;
};
const Body = ({
  children,
  className
}: PaneSlotProps) => <div className={classNames(paneBodyCss, paneSlotPaddingCss, className)} data-testid="side-panel-pane-body">
    {children}
  </div>;
const Footer = ({
  children,
  className
}: PaneSlotProps) => <div className={classNames(paneFooterCss, paneSlotPaddingCss, className)} data-testid="side-panel-pane-footer">
    {children}
  </div>;

/**
 * Header / body / footer column for side-panel panes (`#shell-side-panel`).
 * Body is the sole scroll region; keeps header/footer chrome fixed while tab content scrolls.
 * Header owns its divider and follows PageHeader's vertical spacing at each main-container size.
 * All slots apply responsive inline padding via the `shell-side-panel` container query.
 */
export const SidePanelPaneLayout = Object.assign(Root, {
  Header,
  Body,
  Footer
});

require("./SidePanelPaneLayout.wyw-in-js.css!=!../../../../../node_modules/@wyw-in-js/webpack-loader/lib/outputCssLoader.js?cacheProvider=!./SidePanelPaneLayout.tsx");